module.exports = __webpack_public_path__ + "static/media/cover.913845bb.JPG";